module.exports = __webpack_public_path__ + "static/media/lj.57c6c835.webp";